import "./RevenueIntelligenceFrameworkOurMethodology.module.css";
import Header from "@/reusable_sections/Header";
import RevenueIntelligenceHero from "./sections/RevenueIntelligenceHero";
import HospitalityKpiDeepDive from "./sections/HospitalityKpiDeepDive";
import Forecasting from "./sections/Forecasting";
import Framework from "./sections/Framework";
import Technology from "./sections/Technology";
import Implementation from "./sections/Implementation";
import FrameworkFaqs from "./sections/FrameworkFaqs";
import Services from "./sections/Services";
import Footer from "@/reusable_sections/Footer";
export default function RevenueIntelligenceFrameworkOurMethodologyPage() {
  return <div>
      <Header />
      <RevenueIntelligenceHero />
      <HospitalityKpiDeepDive />
      <Forecasting />
      <Framework />
      <Technology />
      <Implementation />
      <FrameworkFaqs />
      <Services />
      <Footer />
    </div>;
}